import script from "./JdIntroduction.vue?vue&type=script&setup=true&lang=js"
export * from "./JdIntroduction.vue?vue&type=script&setup=true&lang=js"

import "./JdIntroduction.vue?vue&type=style&index=0&id=ba10782c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba10782c"]])

export default __exports__